import Chip from "@mui/material/Chip";

const TONE_TO_COLOR = {
  positive: "success",
  neutral: "default",
};

const StatusChip = ({ label, tone = "neutral" }) => (
  <Chip
    label={label}
    color={TONE_TO_COLOR[tone] || "default"}
    size="small"
    sx={{ maxWidth: 220 }}
  />
);

export default StatusChip;
